// import { FaUserCircle } from 'react-icons/fa';
import { HamburgerIcon } from '@chakra-ui/icons';
import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Link,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import {
  FaMapMarked,
  FaStore,
  FaUser,
  FaReadme,
  FaReceipt,
} from 'react-icons/fa';
import { connect } from 'react-redux';

function MobileSidebar(props) {
  const {
    isOpen: isMobileSideBarOpen,
    onOpen: onMobileSideBarOpen,
    onClose: onMobileSideBarClose,
  } = useDisclosure();

  const { accessModules } = props;
  const userManagementModule = accessModules?.find(
    (a) => a.module === 'user-management',
  );
  const storeManagementModule = accessModules?.find(
    (a) => a.module === 'store-management',
  );
  const storeLocatorModule = accessModules?.find(
    (a) => a.module === 'store-locator',
  );
  const inventoryModule = accessModules?.find(
    (a) => a.module === 'inventory-manager',
  );
  const reportsModule = accessModules?.find((a) => a.module === 'reports');
  console.log('accessModules', accessModules);
  console.log('reportsModule', reportsModule);
  console.log('storeLocatorModule', storeLocatorModule);

  return (
    <Box display={{ base: 'flex', md: 'none' }} minH="inherit" minWidth="60px">
      <IconButton
        rounded="0"
        m="0"
        minWidth="50px"
        onClick={() => {
          onMobileSideBarOpen();
        }}
        icon={<HamburgerIcon w="6" h="6" p="0" m="0" />}
        p="0"
      />
      <Drawer
        closeOnOverlayClick={false}
        isOpen={isMobileSideBarOpen}
        placement="left"
        onClose={onMobileSideBarClose}
        closeOnEsc={false}
      >
        <DrawerOverlay>
          <DrawerContent bg="brand.red" style={{ width: '250px' }}>
            <DrawerCloseButton color="brand.white" />
            <DrawerHeader />
            <DrawerBody>
              <VStack color="white" spacing="4" align="left" width="180px">
                {userManagementModule?.actions.indexOf('full') > -1 && (
                  <Link
                    href="/users"
                    style={{ _hover: 'text-decoration:none' }}
                  >
                    <Flex width="180px" align="center">
                      <FaUser fontSize="30px" />
                      <Text ml="2">User Management</Text>
                    </Flex>
                  </Link>
                )}
                {storeManagementModule?.actions.indexOf('full') > -1 && (
                  <Link href="/stores">
                    <Flex width="180px" align="center">
                      <FaStore fontSize="30px" />
                      <Text ml="2">Store Management</Text>
                    </Flex>
                  </Link>
                )}
                {storeLocatorModule?.actions.indexOf('full') > -1 && (
                  <Link href="/store-locator">
                    <Flex width="180px" align="center">
                      <FaMapMarked fontSize="30px" />
                      <Text ml="2">Store Locator</Text>
                    </Flex>
                  </Link>
                )}
                {/* {reportsModule?.actions.indexOf('full') > -1 && (
                  <Link href="/store-locator">
                    <Flex width="180px" align="center">
                      <FaMapMarked fontSize="30px" />
                      <Text ml="2">Reports</Text>
                    </Flex>
                  </Link>
                )} */}
                {reportsModule?.actions.indexOf('full') > -1 && (
                  <Link href="/reports">
                    <Flex width="200px" align="center">
                      <FaReceipt fontSize="30px" />
                      <Text ml="2">Reports</Text>
                    </Flex>
                  </Link>
                )}
                 {inventoryModule?.actions.indexOf('full') > -1 && (
                  <Link href="/inventory-manager">
                    <Flex width="180px" align="center">
                      <FaMapMarked fontSize="30px" />
                      <Text ml="2">Inventory Manager</Text>
                    </Flex>
                  </Link>
                )}
              </VStack>
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
}

const stateMapper = (state) => ({
  accessModules: state.auth.accessModules,
});
const dispatchMapper = (dispatch) => ({});

export default connect(stateMapper, dispatchMapper)(MobileSidebar);
